<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
  <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding matTreeNodePaddingIndent="20px" (click)="toggleNodeSelected(node)" [class.selected]="node.name === selectedFolderName && node.level === currentLevel"
    (keydown.enter)="toggleNodeSelected(node)" (keydown.space)="$event.preventDefault(); toggleNodeSelected(node)" tabindex="0" matRipple>
    <button mat-icon-button matTreeNodeToggle (keydown.enter)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()"
      [attr.aria-label]="(treeControl.isExpanded(node) ? 'Collapse ' : 'Expand ') + node.name">
      <mat-icon>{{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}</mat-icon>
    </button>
    <mat-icon class="with-text">folder</mat-icon>
    {{ node.name }}
  </mat-tree-node>

  <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding matTreeNodePaddingIndent="20px" (click)="toggleNodeSelected(node)" [class.selected]="node.name === selectedFolderName && node.level === currentLevel"
    (keydown.enter)="toggleNodeSelected(node)" (keydown.space)="$event.preventDefault(); toggleNodeSelected(node)" tabindex="0" matRipple>
    <!-- Adding an empty span to match the indentation for expandable nodes -->
    <span style="width: 40px;"></span>
    <mat-icon class="with-text">folder</mat-icon>
    {{ node.name }}
  </mat-tree-node>
</mat-tree>